export const POST_GRP_BIRTH_DETAILS = "POST_BIRTH_DETAILS"
export const POST_GRP_BIRTH_DETAILS_SUCCESS = "POST_BIRTH_DETAILS_SUCCESS"
export const POST_GRP_BIRTH_DETAILS_FAIL = "POST_BIRTH_DETAILS_FAIL"

export const GET_GRP_ALL_AI_REPORT = "GET_ALL_AI_REPORT"
export const GET_GRP_ALL_AI_REPORT_SUCCESS = "GET_ALL_AI_REPORT_SUCCESS"
export const GET_GRP_ALL_AI_REPORT_FAIL = "GET_ALL_AI_REPORT_FAIL"

export const GET_GRP_AI_REPORT = "GET_AI_REPORT"
export const GET_GRP_AI_REPORT_SUCCESS = "GET_AI_REPORT_SUCCESS"
export const GET_GRP_AI_REPORT_FAIL = "GET_AI_REPORT_FAIL"

export const GET_GRP_AI_REPORT_PDF = "GET_AI_REPORT_PDF"
export const GET_GRP_AI_REPORT_PDF_SUCCESS = "GET_AI_REPORT_PDF_SUCCESS"
export const GET_GRP_AI_REPORT_PDF_FAIL = "GET_AI_REPORT_PDF_FAIL"

// Group
export const GET_ALL_REPORTS = "GET_ALL_REPORTS"
export const GET_ALL_REPORTS_SUCCESS = "GET_ALL_REPORTS_SUCCESS"
export const GET_ALL_REPORTS_FAIL = "GET_ALL_REPORTS_FAIL"
export const GET_ALL_REPORTS_FOR_GROUP_ADMIN = "GET_ALL_REPORTS_FOR_GROUP_ADMIN"
export const GET_ALL_REPORTS_FOR_GROUP_ADMIN_SUCCESS = "GET_ALL_REPORTS_FOR_GROUP_ADMIN_SUCCESS"
export const GET_ALL_REPORTS_FOR_GROUP_ADMIN_FAIL = "GET_ALL_REPORTS_FOR_GROUP_ADMIN_FAIL"
export const GET_BRANCHES = "GET_BRANCHES"
export const GET_BRANCHES_SUCCESS = "GET_BRANCHES_SUCCESS"
export const GET_BRANCHES_FAIL = "GET_BRANCHES_FAIL"

export const GET_GROUP_USERS = "GET_GROUP_USERS"
export const GET_GROUP_USERS_SUCCESS = "GET_GROUP_USERS_SUCCESS"
export const GET_GROUP_USERS_FAIL = "GET_GROUP_USERS_FAIL"

export const GET_REPORT = "GET_REPORT"
export const GET_REPORT_SUCCESS = "GET_REPORT_SUCCESS"
export const GET_REPORT_FAIL = "GET_REPORT_FAIL"

export const GET_GROUP_MASTERS = "GET_GROUP_MASTERS"
export const GET_GROUP_MASTERS_SUCCESS = "GET_GROUP_MASTERS_SUCCESS"
export const GET_GROUP_MASTERS_FAIL = "GET_GROUP_MASTERS_FAIL"





